import type { Routes } from '@angular/router';
import {
    createActionTriggerDealer,
    createMetaResolverWithDealer,
    defaultTitleResolver,
    HyundaiPromiseFeature,
    ngrxLoaderGuard,
    PageContentType,
} from '@hyundai/ng-common-lib';
import { PromisePageComponent } from './promise-page.component';

export default [
    {
        path: '',
        component: PromisePageComponent,
        canActivate: [
            ngrxLoaderGuard({
                redirectOnFailUrl: '/',
                waitUntilLoadedSelector: HyundaiPromiseFeature.state.selectIsLoadingPromise,
                dataToCheckSelector: HyundaiPromiseFeature.state.selectLoadedContent,
            }),
        ],
        providers: [createActionTriggerDealer(HyundaiPromiseFeature.actions.loadHyundaiPromise())],
        title: defaultTitleResolver('Hyundai Promise'),
        resolve: {
            meta: createMetaResolverWithDealer((dealer) => {
                return {
                    description: `Mit Hyundai Promise profitieren Sie von einer großen Auswahl zertifizierter Gebrauchtfahrzeuge bei ${dealer.name} ${dealer.city}.`,
                };
            }),
        },
        data: {
            contentType: PageContentType.PROMISE,
        },
    },
] satisfies Routes;
